var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center text-muted my-2"},[_c('b-spinner',{staticClass:"align-middle"}),_c('strong',[_vm._v(_vm._s(_vm.label)+"...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }